module.exports = __webpack_public_path__ + "img/4.b7691f95.png";